import DoughnutChart from '../components/DoughnutChart';
import { MedicationsBlueIcon } from '../assets/svgImages';
import moment from 'moment';
import { renderStatusColor } from '../constant/constant';
import {
  MonthlyLimitComponentProps,
  MonthlyLimitPrescriptionProps,
  PrescriptionStatus,
} from '../interface/interface';

const MonthlyLimit = (props: MonthlyLimitComponentProps) => {
  return (
    <div>
      <div className="bg-white rounded-md px-10 py-8 shadow">
        <h3 className="text-2xl md:text-3xl font-bold text-primary-blue-500 mb-6">
          Monthly Limit - <span>{props?.type}</span>
        </h3>
        <div className="grid grid-cols-1">
          <div className="col-span-1">
            <DoughnutChart data={props?.products} unit={props?.unit} />
          </div>
        </div>
      </div>
      <div className="bg-secondary-cornflowerblue-50 rounded mt-7 px-10 py-6">
        <h3 className="text-2xl md:text-2xl font-semibold text-primary-blue-500 mb-6">
          Monthly Product Limits
        </h3>
        {props?.prescriptions?.map(
          (pres: MonthlyLimitPrescriptionProps, index: number) => (
            <div key={index + 1}>
              <div className="flex flex-col">
                <div className="bg-white rounded-md p-4 md:p-7 mb-3 relative">
                  <div className="grid grid-cols-1 xl:grid-cols-5 gap-4">
                    <div className="col-span-1 xl:col-span-2 flex flex-col sm-land:flex-row">
                      <div className="w-1/4 flex flex-col justify-center items-center">
                        <img
                          className="w-10/12 xl:w-28"
                          src={pres?.imageUrl}
                          alt={`product-image-${index + 1}`}
                        />
                      </div>
                      <div className="w-3/4">
                        <p className="text-lg md:text-2xl text-primary-blue-500 font-semibold mt-3 md:mt-0">
                          {pres?.product_name}
                        </p>
                        <div className="bg-grey-50 px-3 py-2 rounded flex items-center w-full 2xl:w-80 shadow mt-3">
                          <p className="flex border-r border-primary-blue-500 pr-3 items-center w-2/5">
                            <MedicationsBlueIcon />
                            <span className="text-sm text-primary-blue-500 font-semibold ml-1">
                              Number
                            </span>
                          </p>
                          <p className="text-sm text-primary-blue-500 font-regular pl-3 w-3/5">
                            {pres?.prescription_code}
                          </p>
                        </div>
                        <div className="bg-grey-50 px-3 py-2 rounded flex items-center w-full 2xl:w-80 shadow mt-3">
                          <p className="flex border-r border-primary-blue-500 w-2/5 pr-3 items-center">
                            <MedicationsBlueIcon />
                            <span className="text-sm text-primary-blue-500 font-semibold ml-1">
                              Expiry
                            </span>
                          </p>
                          <p className="text-sm text-primary-blue-500 font-regular pl-3 w-3/5">
                            {moment(pres?.expiry).isValid()
                              ? moment(pres.expiry).format('DD/MM/YYYY')
                              : ''}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-1 xl:col-span-3 grid grid-cols-1 lg:grid-cols-4">
                      <div className="col-span-1 flex flex-col justify-end">
                        {pres.status === PrescriptionStatus.Active ? (
                          <div className="bg-secondary-green-100 rounded px-2 md:px-4 py-2 inline-flex items-center mb-2">
                            <span
                              className={`w-2.5 h-2.5 rounded-full mr-2.5 ${
                                pres?.isIntervalReached > 0
                                  ? 'bg-primary-red-600'
                                  : 'bg-secondary-green-600'
                              }`}
                            ></span>
                            <span className="text-xs md:text-sm font-semibold text-primary-blue-500">
                              Interval{' '}
                              {pres?.isIntervalReached > 0 ? '' : 'not'} reached
                            </span>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div
                          className={`${renderStatusColor(pres?.status)} px-2.5 py-2 rounded flex items-center `}
                        >
                          <span
                            className={`${renderStatusColor(pres?.status, false)} rounded-full w-2.5 h-2.5 mr-3 inline-block`}
                          ></span>
                          <span className="text-sm font-semibold text-primary-blue-500">
                            {`${pres?.status?.charAt(0)?.toUpperCase()}${pres?.status?.slice(1)}`}
                          </span>
                        </div>
                      </div>
                      <div
                        className="grid grid-cols-1 lg:grid-cols-3 gap-4 col-span-1 lg:col-span-3 bg-secondary-pink-50 
                  lg:ml-5 self-end p-4 rounded mt-4 xl:mt-0"
                      >
                        <div className="col-span-1 xl:text-center xl:border-r xl:border-grey-600 flex justify-between items-center lg:block">
                          <label className="text-base 3xl:text-lg text-primary-blue-500 font-semibold">
                            Repeats
                            <br /> Remaining
                          </label>
                          <p className="text-sm text-primary-blue-500 font-regular">
                            {pres?.repeats}
                          </p>
                        </div>
                        <div className="col-span-1 xl:text-center xl:border-r xl:border-grey-600 flex justify-between items-center lg:block">
                          <label className="text-base 3xl:text-lg text-primary-blue-500 font-semibold">
                            Dispensing
                            <br /> Interval
                          </label>
                          <p className="text-sm text-primary-blue-500 font-regular">
                            {pres?.interval} days
                          </p>
                        </div>
                        <div className="col-span-1 xl:text-center flex justify-between items-center lg:block">
                          <label className="text-base 3xl:text-lg text-primary-blue-500 font-semibold">
                            Amount
                            <br /> Consumed ({props?.unit})
                          </label>
                          <p className="text-sm text-primary-blue-500 font-regular">
                            {pres?.consumed}
                            {props?.unit}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
};

export default MonthlyLimit;
